"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const temaPadrao = styles_1.createMuiTheme({
    palette: {
        type: 'light',
        primary: {
            light: '#00f769',
            main: '#00d867',
            dark: '#009c4e',
            contrastText: '#fff',
        },
        secondary: {
            light: 'rgb(255,153,86)',
            main: '#fa7934',
            dark: '#d09229',
            contrastText: '#fff',
        },
        error: {
            light: '#e57373',
            main: '#f44336',
            dark: '#d32f2f',
            contrastText: '#fff',
        },
    },
    typography: {
        useNextVariants: true,
    },
});
exports.default = temaPadrao;
//# sourceMappingURL=temaPadrao.js.map